export const htmlToPlainText = (html) => {
    if (!html) {
        return "";
    }
    
    // Primero manejamos algunos casos especiales que requieren conversión a saltos de línea
    let text = html
        .replace(/<br\s*\/?>/gi, "\n")
        .replace(/<p><\/p>/gi, "\n")
        .replace(/<\/p>/gi, "\n");
        
    // Luego eliminamos todas las etiquetas HTML
    text = text.replace(/<[^>]*>/g, '');
    
    // Decodificamos entidades HTML comunes
    text = text
        .replace(/&nbsp;/g, ' ')
        .replace(/&amp;/g, '&')
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>')
        .replace(/&quot;/g, '"')
        .replace(/&#39;/g, "'");
    
    // Eliminamos espacios extra y normalizamos los saltos de línea
    return text.trim();
};

export const parseHTMLTextToString = (str) => {
    if ((str === null) || (str === ''))
        return false;
    else
        str = str.toString();
        
    // Eliminar todas las etiquetas HTML
    return str.replace(/<[^>]*>/g, '');
}